import { render, staticRenderFns } from "./AddTalkgroup.vue?vue&type=template&id=9ef1430e&scoped=true"
import script from "./AddTalkgroup.vue?vue&type=script&lang=js"
export * from "./AddTalkgroup.vue?vue&type=script&lang=js"
import style0 from "./AddTalkgroup.vue?vue&type=style&index=0&id=9ef1430e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef1430e",
  null
  
)

export default component.exports